export enum SeatConfigurationType {
  GENERAL_ADMISSION = 'GENERAL_ADMISSION',
  SEATED = 'SEATED',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/seat-configuration-type.ts